
/**
 * Get the preview of the last message
 * @param {Object} lastMessage 
 * example:
 * {
 *   msg: 'Hello, how are you?',
 *   attachments: [
 *     {
 *       title: 'name',
 *       value: 'John Doe',
 *     },
 *   ],
 *   t: 'order_card',
 * }
 * @returns {string} the preview of the last message or null if no preview is available
 */
export function getLastMessagePreview(lastMessage) {
  if (!lastMessage) return null;
  
  // Check message type first for specific card types
  if (lastMessage.t === 'image') {
    return '[Image]';
  }
  if (lastMessage.t === 'doc_card') {
    return '[File]';
  }
  if (lastMessage.t === 'order_card') {
    return '[Order]';
  }
  if (lastMessage.t === 'appointment_card') {
    return '[Appointment]';
  }
  if (lastMessage.t === 'task_card') {
    return '[Task]';
  }
  
  // Return text message if available
  if (lastMessage.msg) {
    return lastMessage.msg;
  }
  
  // Fallback for other attachment types
  if (lastMessage.attachments && lastMessage.attachments.length > 0) {
    let lastAttachment = lastMessage.attachments[0];
    let attachmentProperties = {};
    
    // Handle old format with fields array
    if (lastAttachment.fields && Array.isArray(lastAttachment.fields)) {
      lastAttachment.fields.forEach(f => {
        attachmentProperties[f.title] = f.value;
      });
      return attachmentProperties.name || null;
    }
    
    // Handle new format with addon_column
    if (lastAttachment.addon_column) {
      const addonColumn = lastAttachment.addon_column;
      return addonColumn.event_title || addonColumn.title || addonColumn.notification_type || null;
    }
    
    return null;
  }
  return null;
}